/* eslint-disable react-hooks/rules-of-hooks */
import axios from "axios";
import {
    countState,
    netPriceState,
    imageCountState,
    totalPriceState,
    discountPriceState,
    discountPercentageState,
    framePricesState,
    defaultFramePriceState,
    discountConfigState
} from "@atoms/priceCalc";
import {imagesData} from "@atoms";
import {getRecoil, setRecoil} from "recoil-nexus";
import {imagesBlobState, loaderState} from "../Recoil/Atoms";
import {getActivePromoEvent} from "./activePromoEvent";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export async function uploadSingleImage(formdata) {
    if(localStorage.getItem("orderId")) {
        localStorage.removeItem("orderId");
    }

    const response = await axios
        .post(`${BASE_URL}/imageupload_single`, formdata, {
            headers: {
                "content-type": "multipart/form-data",
            },
            //responseType: "blob",
        })

    await getImagesDB();

    return response;
}

export async function uploadMultipleImages(formdata) {
    const response = await axios
        .post(`${BASE_URL}/imageupload`, formdata, {
            headers: {
                "content-type": "multipart/form-data",
            },
        })

    await getImagesDB();

    return response;
}

export function removeImage(id) {
    if(localStorage.getItem("orderId")) {
        localStorage.removeItem("orderId");
    }

    // The server deletes only an image that belongs to this uid or sits in this
    // gallery's cart, so both go along. POST: a GET link could be fired by a crawler.
    const uid = localStorage.getItem("uniqueUserId") || "";
    const sessionId = localStorage.getItem("sessionId") || "";
    const userEmail = localStorage.getItem("userEmail") || "";

    return axios.post(`${BASE_URL}/delete_image_by_user/${encodeURIComponent(id)}`, { uid, sessionId, email: userEmail });
}

export function getUserImages() {
    const localstr = localStorage.getItem("uniqueUserId");
    return axios.get(`${BASE_URL}/get_image_by_user/${localstr}`);
}

export async function addImageFromSocial(response) {
    if(localStorage.getItem("orderId")) {
        localStorage.removeItem("orderId");
    }

    const rep = await axios.post(`${BASE_URL}/social-photo-import`, response, {
        headers: {
            "content-type": "application/json",
        },
    })

    await getImagesDB();

    return rep;
}

export async function getImagesDB() {
    const count = getRecoil(countState);
    const imageBlobs = getRecoil(imagesBlobState);
    const imageData = await getUserImages();
    const loadedImagesIds = imageData.data.data.map(item => item.publicId);

    const filteredBlobs = imageBlobs.filter(oldBlob => !loadedImagesIds.includes(oldBlob.id));


    if (filteredBlobs.length === 0 && imageBlobs.length > 0) {
        setRecoil(loaderState, {
            showText: false,
            showLoader: true,
            show50: false,
            show100: true,
        });

        setTimeout(() => {
            setRecoil(loaderState, {
                showLoader: false,
                show50: false,
                show100: false,
                showText: true,
            });

            setTimeout(() => {
                setRecoil(loaderState, {
                    showLoader: false,
                    show50: false,
                    show100: false,
                    showText: false,
                });
            }, 3500);
        }, 500);
    }
    setRecoil(countState, count + 2);
    if (imageData.data.data.length > 0) {
        const imageshow = imageData.data.data;
        setRecoil(imagesData, imageshow);
        setRecoil(imageCountState, imageshow.length);

        // Get the current frame type from localStorage or use a default
        const currentFrameType = localStorage.getItem("frameSelected") || "classic";
        
        // Get the frame prices from Recoil state
        const framePrices = getRecoil(framePricesState);
        const defaultFramePrice = getRecoil(defaultFramePriceState);
        
        // Get the price for the current frame type, or fall back to the default price
        const framePrice = framePrices[currentFrameType] || defaultFramePrice;
        
        let set_net_price = imageshow.length * framePrice;
        let set_discount_percentage = 0;
        let set_discount_price = 0;
        let set_total_price = 0;

        // On a special-day discount event, mirror the event's tier table (folded
        // into discountConfigState by the server) so this default display matches
        // the discount the coupon/tier path will charge. Baseline (non-event) days
        // keep the original hardcoded behavior untouched.
        const activeEvent = getActivePromoEvent();
        const eventTiers = activeEvent ? (getRecoil(discountConfigState)?.tiers || []) : [];
        const eventTier = eventTiers
            .filter((t) => imageshow.length >= t.imageCount)
            .sort((a, b) => b.imageCount - a.imageCount)[0];

        if (eventTier) {
            set_discount_percentage = eventTier.discount;
            set_discount_price = (
                (set_discount_percentage / 100) *
                parseFloat(set_net_price)
            ).toFixed(2);
            set_total_price = set_net_price - set_discount_price;
        } else if (imageshow.length > 9 && imageshow.length < 15) {
            set_discount_percentage = 5;
            set_discount_price = (
                (set_discount_percentage / 100) *
                parseFloat(set_net_price)
            ).toFixed(2);
            set_total_price = set_net_price - set_discount_price;
        } else if (imageshow.length > 14) {
            set_discount_percentage = 10;
            set_discount_price = (
                (set_discount_percentage / 100) *
                parseFloat(set_net_price)
            ).toFixed(2);
            set_total_price = set_net_price - set_discount_price;
        }

        // Functional update: this runs after EVERY single upload, and between the
        // getRecoil snapshot above and this write, UploadOptions may have pushed
        // or patched blob entries. Replacing with the stale `filteredBlobs`
        // snapshot wiped those (tile vanishes, and imagesBlob.length can hit 0
        // while uploads are still in flight — opening the checkout gate early).
        setRecoil(imagesBlobState, (current) =>
            current.filter((oldBlob) => !loadedImagesIds.includes(oldBlob.id)));
        setRecoil(netPriceState, set_net_price);
        setRecoil(discountPercentageState, set_discount_percentage);
        setRecoil(discountPriceState, set_discount_price);
        setRecoil(totalPriceState, set_total_price);
    }
    return imageData;
}

export async function checkOrderStatus() {
    try {
        const response = await axios.get(`${BASE_URL}/user/checkorder/${localStorage.getItem("orderId")}`);
        return response;
    } catch (err) {
        console.error('checkOrderStatus error:', err.message);
    }
}

export async function logAddressConfirmation(addressData, deviceType, imageUrls, cropData, imageCount, frameType) {
    try {
        const uid = localStorage.getItem("uniqueUserId");
        const sessionId = localStorage.getItem("sessionId") || "";
        const userEmail = localStorage.getItem("userEmail") || "";
        const logIdentifier = userEmail ? `[${uid}-${userEmail}]` : `[${uid}]`;
        
        const response = await axios.post(`${BASE_URL}/log-address-confirmation`, {
            addressData,
            deviceType,
            uid,
            imageUrls,
            cropData,
            imageCount,
            frameType,
            sessionId
        });
        
        return response;
    } catch (err) {
        console.error(`Error logging address confirmation: ${err.message}`);
        throw err;
    }
}

export async function updatePurchaseStatus(sessionId, orderId, amount, paymentMethod) {
    try {
        const uid = localStorage.getItem("uniqueUserId");
        const userEmail = localStorage.getItem("userEmail") || "";
        const logIdentifier = userEmail ? `[${uid}-${userEmail}]` : `[${uid}]`;
        
        
        // BASE_URL already ends in /api (was /api/api/... -> 404 since 2025-06).
        const response = await axios.post(`${BASE_URL}/addtocart/purchase-status`, {
            sessionId,
            orderId,
            amount,
            paymentMethod
        });
        
        return response;
    } catch (err) {
        console.error(`Error updating purchase status: ${err.message}`);
        throw err;
    }
}

// ===== Personal Area API =====

export async function sendPersonalOtp(contact, channel = 'sms') {
    const body = channel === 'email'
        ? { email: contact, channel: 'email' }
        : { phoneNumber: contact };
    const response = await axios.post(`${BASE_URL}/personal/send-otp`, body);
    return response.data;
}

export async function verifyPersonalOtp(contact, code, channel = 'sms') {
    const body = channel === 'email'
        ? { email: contact, code, channel: 'email' }
        : { phoneNumber: contact, code };
    const response = await axios.post(`${BASE_URL}/personal/verify-otp`, body);
    return response.data;
}

// ===== Gallery merge (split-cart recovery) API =====

// sessionId is optional for candidates/send-otp (it only excludes the current
// cart) — a fresh browser with no cart yet is looked up by email/phone alone.
export async function getMergeCandidates(extra = {}) {
    const sessionId = localStorage.getItem("sessionId") || null;
    const response = await axios.post(`${BASE_URL}/merge/candidates`, { sessionId, ...extra });
    return response.data;
}

export async function sendMergeOtp(channel, extra = {}) {
    const sessionId = localStorage.getItem("sessionId") || null;
    const response = await axios.post(`${BASE_URL}/merge/send-otp`, { sessionId, channel, ...extra });
    return response.data;
}

export async function confirmMerge(code, extra = {}) {
    const sessionId = localStorage.getItem("sessionId");
    const response = await axios.post(`${BASE_URL}/merge/confirm`, { sessionId, code, ...extra });
    return response.data;
}

export function logMergeEvent(type, source) {
    const sessionId = localStorage.getItem("sessionId");
    // fire-and-forget — analytics must never block the UI
    axios.post(`${BASE_URL}/merge/event`, { sessionId, type, source }).catch(() => {});
}

// Debug breadcrumb: browser console + server terminal (so QA on a phone can
// follow the merge flow without DevTools). Never blocks, never throws.
export function mergeDebug(msg) {
    console.log(`[merge:client] ${msg}`);
    const sessionId = localStorage.getItem("sessionId");
    axios.post(`${BASE_URL}/merge/event`, { sessionId, type: "debug", msg }).catch(() => {});
}

export async function getPersonalOrders(token, days = 90) {
    const response = await axios.get(`${BASE_URL}/personal/orders`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { days },
    });
    return response.data;
}

export async function getPersonalOrderDetail(token, oid) {
    const response = await axios.get(`${BASE_URL}/personal/orders/${oid}`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
}

export async function enableOrderEdit(token, oid) {
    const response = await axios.post(`${BASE_URL}/personal/orders/${oid}/enable-edit`, {}, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
}

export async function saveOrderEdit(token, oid, data) {
    const response = await axios.put(`${BASE_URL}/personal/orders/${oid}/save-edit`, data, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
}

// data: { imageName? | imageId?, croppedImage: dataURL, bwFilter? }
export async function replacePersonalOrderImage(token, oid, data) {
    const response = await axios.post(`${BASE_URL}/personal/orders/${oid}/replace-image`, data, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
}

// data: { imageName? | imageId?, bw: boolean }
export async function setPersonalOrderImageEffect(token, oid, data) {
    const response = await axios.post(`${BASE_URL}/personal/orders/${oid}/image-effect`, data, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
}

// ===== Credits API =====

export async function getCreditsBalance(token) {
    const response = await axios.get(`${BASE_URL}/personal/credits`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
}

export async function applyCredits(token, sessionId, amount) {
    const response = await axios.post(`${BASE_URL}/personal/apply-credits`, { sessionId, amount }, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
}

export async function removeCredits(token, sessionId) {
    const response = await axios.post(`${BASE_URL}/personal/remove-credits`, { sessionId }, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
}
